import { ValueFunction, extendIndex, subtract } from "@/js/model/Functions";
import { Model } from "@/js/model/Model";
import { FixedSeries } from "@/js/model/DataSeries";

const _ = require('lodash');


let m = new Model('AMM Impermanent Loss');

// Key Model Inputs
m.addComponent('Token A Price')
  .setData(new FixedSeries(2000));

m.addComponent('Token B Price')
  .setData(new FixedSeries(10));

m.addComponent('Input Amount')
  .setData(new FixedSeries(10));


/**
 * CALCULATED COMPONENTS
 */

// Token Amounts
const tokenAmountFunc = new ValueFunction(
  ({totalUsdAmount, tokenUsdPrice}) => totalUsdAmount * 0.5 / tokenUsdPrice,
  {
    label: 'Calculate Token Amount'
  }
);

m.addComponentWithMethod('Token A Amount',
  tokenAmountFunc,
  {
    totalUsdAmount: 'Input Amount',
    tokenUsdPrice: 'Token A Price'
  }
);

m.addComponentWithMethod('Token B Amount',
  tokenAmountFunc,
  {
    totalUsdAmount: 'Input Amount',
    tokenUsdPrice: 'Token B Price'
  }
);


// Price Forecasts
m.addComponentWithMethod('Token A Price Forecast',
  extendIndex,
  { series: 'Token A Price', steps: 100 }
);

m.addComponentWithMethod('Token B Price Forecast',
  extendIndex,
  { series: 'Token B Price', steps: 100 }
);


// Token Forecasts
const xTokenChange = new ValueFunction(
  ({xPerUSD, yPerUSD, amountOne, amountTwo}) => 
    Math.sqrt((xPerUSD / yPerUSD) * amountOne * amountTwo),
  {
    label: 'Pool '
  }
);

m.addComponentWithMethod('Token A Amount Forecast',
  xTokenChange,
  {
    xPerUSD: 'Token B Price Forecast',
    yPerUSD: 'Token A Price Forecast',
    amountOne: 'Token A Amount',
    amountTwo: 'Token B Amount'
  }
);

m.addComponentWithMethod('Token B Amount Forecast',
  xTokenChange,
  {
    xPerUSD: 'Token A Price Forecast',
    yPerUSD: 'Token B Price Forecast',
    amountOne: 'Token A Amount',
    amountTwo: 'Token B Amount'
  }
);


// Final Calculations
const sumProduct = new ValueFunction(
  ({priceA, amountA, priceB, amountB}) => priceA * amountA + priceB * amountB,
  {
    label: 'Total Value Calculation'
  }
);

m.addComponentWithMethod('Pool Value Forecast',
  sumProduct,
  {
    priceA: 'Token A Price Forecast',
    amountA: 'Token A Amount Forecast',
    priceB: 'Token B Price Forecast',
    amountB: 'Token B Amount Forecast'
  }
);

m.addComponentWithMethod('HODL Value Forecast',
  sumProduct,
  {
    priceA: 'Token A Price Forecast',
    amountA: 'Token A Amount',
    priceB: 'Token B Price Forecast',
    amountB: 'Token B Amount'
  }
);

// Combine the total values into a single node
m.nodes.addToNode('Total Value Scenarios',
  ['HODL Value Forecast','Pool Value Forecast']
);


// Impermanent Loss
m.addComponentWithMethod('Impermanent Loss',
  subtract,
  {
    a: 'HODL Value Forecast',
    b: 'Pool Value Forecast'
  }
);


export const template = {
  'Label': 'Liquidity Pool Impermanent Loss',
  'Category': 'Crypto / Defi',
  'Description': 'Calculate the potential impermanent loss of providing liquidity on an automated market maker',
  'model': m
}